export default function Carte() {
  return (
    <section className="bg-[#F5F2EB] py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-[#1B2A4A] text-2xl md:text-3xl font-extrabold text-center mb-10 md:mb-14">
          Où nous trouver
        </h2>
        <div className="rounded-xl overflow-hidden border border-[#E2E8F0] h-[400px] md:h-[500px]">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2639.1234567890!2d7.712345!3d48.583456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4796c84e4e0e0e0e%3A0x0!2s82%20Rue%20de%20Heidenberg%2C%2067200%20Strasbourg%2C%20France!5e0!3m2!1sfr!2sfr!4v1600000000000!5m2!1sfr!2sfr"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Carte de localisation de l'agence Dépan'Volets Strasbourg - 82 Rue de Heidenberg, 67200 Strasbourg"
            aria-label="Carte Google Maps centrée sur l'agence Dépan'Volets Strasbourg, 82 Rue de Heidenberg, 67200 Strasbourg"
          ></iframe>
        </div>
      </div>
    </section>
  );
}